import React, { useState } from "react";
import { useSection } from "../../../i18n/useSection";

const SensorTypeSetup = ({ onBack, onLink, saving }) => {
  const t = useSection("activityMonitoring");
  const [sensorId, setSensorId] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (!sensorId.trim() || saving) return;
    const ok = await onLink(sensorId.trim());
    if (!ok) return;
    setSensorId("");
  };

  return (
    <div className="sensor-type-setup">
      <header className="sensor-type-header">
        <button type="button" onClick={onBack} aria-label={t.back}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M19 12H5m7-7-7 7 7 7" />
          </svg>
        </button>
        <h1>{t.title}</h1>
      </header>

      <main>
        <div className="sensor-setup-heading">
          <h2>{t.setup_title}</h2>
          <p>{t.setup_description}</p>
        </div>

        <section className="sensor-link-card">
          <form onSubmit={submit}>
            <label htmlFor="sensor-id">{t.sensor_id}</label>
            <input
              id="sensor-id"
              type="text"
              value={sensorId}
              onChange={(event) => setSensorId(event.target.value)}
              placeholder={t.sensor_placeholder}
              disabled={saving}
              autoFocus
            />
            <p className="sensor-id-help">{t.sensor_help}</p>
            <button
              type="submit"
              className="sensor-link-submit"
              disabled={!sensorId.trim() || saving}
            >
              {saving ? t.linking : t.verify_link}
            </button>
          </form>
        </section>
      </main>
    </div>
  );
};

export default SensorTypeSetup;
